/**
 * GroupeActivites Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from '../../../constants/AppConfig';
import i18n from "@/plugins/i18n";

// States
const state = {
    groupeActivites: [],
    groupeActivite: {},
    activites:[],
    activite: {},
};

// Getters
const getters = {
    groupeActivites: state => {
        return state.groupeActivites
    },

    activites: state => {
        return state.activites
    },

    activite: state => {
        return state.activite
    },

    groupeActivite: state => {
        return state.groupeActivite
    }
};

// Actions
const actions = {
    getGroupeActivites(context, payload) {
        function successCallback(response) {
            context.commit('getGroupeActivitesHandler', { groupeActivites: response.data.activites });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getActivites(context, payload) {
        function successCallback(response) {
            context.commit('getActivitesHandler', { activites: response.data.activites });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getActivite(context, payload) {
        function successCallback(response) {
            context.commit('getActiviteHandler', { activite: response.data.activite });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    CreateActivite(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'activite' , params:{groupe:response.data.activite.groupe.slug,activite:response.data.activite.slug}});
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    UpdateActivite(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'activite' , params:{groupe:response.data.activite.groupe.slug,activite:response.data.activite.slug}});
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getActivitesPerGroupe(context, payload) {
        function successCallback(response) {
            context.commit('getActivitesHandler', { activites: response.data.activites });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Group, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getGroupeActivite(context, payload) {
        function successCallback(response) {
            context.commit('getGroupeActiviteHandler', { groupeActivite: response.data.groupeActivite });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Group, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteActivite(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'activites' , params:{groupe:response.data.activite.groupe.slug}});
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    cloturerActivite(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getActiviteHandler', { activite: response.data.activite });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Cloturer, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    modifierActiviteMission(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('updateActiviteMission', { mission: response.data.mission,index:payload.index });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Mission.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteActiviteMission(context, payload) {
        function successCallback(response) {
            context.commit('deleteActiviteMissionHandler', {index:payload.index });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Mission.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    ajouterActiviteMission(context, payload) {
        function successCallback(response) {
            context.commit('addActiviteMission', { mission: response.data.mission });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.GroupeActivite.Activite.Mission.Add, localToken, successCallback, errorCallback);
    },
};

// Mutations
const mutations = {
    getGroupeActivitesHandler(state, { groupeActivites }) {
        // Update groupeActivites state
        state.groupeActivites = groupeActivites;
    },

    getActivitesHandler(state, { activites }) {
        // Update groupeActivites state
        state.activites = activites;
    },

    getActiviteHandler(state, { activite }) {
        // Update groupeActivites state
        state.activite = activite;
    },

    updateActiviteMission(state,{mission, index}){
        Vue.swal(
            i18n.t('message.activite.mission.update'),
            '',
            'success'
        );
        state.activite.missions.splice(index,1,mission);
    },

    deleteActiviteMissionHandler(state,{index}){
        Vue.swal(
            i18n.t('message.activite.mission.delete'),
            '',
            'success'
        );
        state.activite.missions.splice(index,1);
    },

    addActiviteMission(state,{mission}){
        Vue.swal(
            i18n.t('message.activite.mission.add'),
            '',
            'success'
        );

        state.activite.missions.push(mission);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}